// @flow

import React, { Component } from 'react'

import Loading from '../Icons/loading.gif'
import './SearchWordCloud.css'

type Props = {
  data: Array
}

/**
  * Diplay for search word cloud
  * @class
  * @extends Component
*/
class SearchWordCloud extends Component<Props> {
  /** render function */
  render () {
    let list
    if (this.props.data) {
      list = this.props.data.map((term, index) => {
        if (term === 'Loading') {
          return <img key={index} src={Loading} alt='Loading' />
        } else {
          return <span key={index}>{term}</span>
        }
      })
    } else {
      list = ''
    }
    return (
      <div className='SearchWordCloud box' style={{ marginRight: '16px' }}>
        <h4>
          Most Searched Terms
        </h4>

        <div className='flex'>
          {list}
        </div>
      </div>
    )
  }
}

export default SearchWordCloud
